import { Select } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useState } from "react";
import classes from "./FilterSelect.module.css";

export const FilterSelect = ({ onChange, ...props }) => {
    const [opened, setOpened] = useState(false);

    return (
        <Select
            w={140}
            radius={8}
            variant="default"
            clearable
            onDropdownOpen={() => setOpened(true)}
            onDropdownClose={() => setOpened(false)}
            className={classes.select}
            classNames={{ dropdown: classes.dropdown }}
            rightSectionPointerEvents="none"
            rightSection={opened
                ? <IconChevronUp size={16} className={classes.chevron} />
                : <IconChevronDown size={16} className={classes.chevron} />}
            onChange={(value) => onChange(value || null)}
            {...props}
        />
    );
};
